export default __webpack_public_path__ + "static/media/calendar_view_month.5ca3d075.svg";